if(typeof adSection === 'undefined') {
	var adSection = 'pd';
	console.warn('\'adSection\' is undefined. Failure to define this variable before loading this script as well as dfploader.js will cause our ads to target incorrectly.');
}


// NBBJ OVERRIDES
if(adSection === 'nbbj/news/wine')
	adSection = 'nbbj/industrynews/wineindustry';


// PD OVERRIDES
if(adSection === 'pd/specialsections/sonomagives')
	adSection = 'pd/specialsections/sonomagiving';

// REMOVED 2021-12-01 PER REQUEST FROM BERNICE
//if(adSection === 'pd/specialsections/gratitude')
	//adSection = 'pd/specialsections/celebrations';

if(window.location.href.indexOf('t=2021_drought') !== -1)
	adSection = "pd/specialsections/insight";

if(adSection === 'pd/news/insight')
	adSection = "pd/specialsections/insight";

if(adSection === 'pd/specialsections/fallartsentertainment')
	adSection = 'pd/specialsections/fall-arts';

/**
 * This file needs to be loaded after jQuery is loaded, but has no other dependencies.
 *
 * Loading the file will automatically load the DFP scripts and set the 'googletag' global. No other script tags are
 * required within the html document.
 *
 * A query string value of 'dfpDebug=1' on any page running this script will output debug info to the browser console.
 *
 *
 * REQUIRED GLOBALS (apply to all ads on page)
 *
 * Ad Path - which page or section we are targeting ads to
 *   smiDfp.defaultAdSection = 'pd/home' // can be set to any ad path (i.e. pd/sports or pd/lifestyles/food)
 *
 * Ad Breakpoints - at which pixel width we break into a different sized ad. Can define as many as needed
 *   smiDfp.addBreakpoint(bpName, minWidth, maxWidth, renderCSS);   // set render CSS to 'true' for last defined breakpoint
 *
 *   EXAMPLE
 *   smiDfp.addBreakpoint('phone', 0, '767px', false);              // sets breakpoint 'phone' for screens up to 767px wide
 *   smiDfp.addBreakpoint('tablet', '768px', '1024px', false);      // sets breakpoint 'tablet' between 768px & 1024px wide
 *   smiDfp.addBreakpoint('desktop', '1025px', 0, true);            // sets breakpoint 'desktop' for screens 1025px or wider
 *
 *
 * OPTIONAL GLOBALS (apply to all ads on page)
 *
 * Keywords - define keywords to be set for ad services to target for inclusion or exclusion of ads (i.e. wildfire or lawsuit)
 *   smiDfp.addKeyword('wildfire');
 *   smiDfp.addKeyword('lawsuit');
 *   smiDfp.addKeyword('someotherword');
 *
 * Keyword Selectors - required if 'keywords' are defined. Tells the script which jQuery selectors to look for keywords in.
 *   smiDfp.addKeywordSelector('h1:visible');
 *   smiDfp.addKeywordSelector('.article-text');
 *
 * User Experiences - used to change the experiences of individual users. Individual ads can be set to ignore these.
 *    smiDfp.setAdLite();
 *    smiDfp.unsetAdLite();
 *    smiDfp.setAdFree();
 *    smiDfp.unsetAdFree();
 *
 *
 * GLOBAL FUNCTIONS TO BUILD INDIVIDUAL ADS
 *
 * smiDfp.buildAd(visibleFor, style, tag);      // used to create a new ad (i.e. var ad = smiDfp.buildAd('desktop'))
 *                                              // - visibleFor     one or more comma delimited breakpoints as defined by defined by smiDfp.addBreakpoint()
 *                                              // - style          [optional] CSS styles to apply to the ad div (i.e. 'margin: 1em auto; border: 1px solid #000;')
 *                                              // - tag            [optional] Which HTML tag do you want the ad served out of? (default 'div')
 *
 * smiDfp.copy(ad, visibleFor);                 // create a copy of an object created using smiDfp.buildAd()
 *                                              // - ad             object created using smiDfp.buildAd(). Will copy all properties set at point it was copied.
 *                                              // - visibleFor     [optional] If you want the copy visible for different breakpoints. Copies existing if left blank.
 *
 * smiDfp.buildAdWrapper(cssClass, style, tag); // create a wrapper to enclose ad(s) in. Can be used to add styles to parent of ad.
 *                                              // - cssClass       [optional] CSS class you want added to the outer wrapper for the ads.
 *                                              // - style          [optional] CSS styles to apply to the wrapper (i.e. 'margin: 1em auto; border: 1px solid #000;')
 *                                              // - tag            [optional] Which HTML tag do you want the wrapper to be? (default 'div')
 *
 *
 * METHODS USED TO MODIFY ADS
 *
 * addSize(width, height)       // add an available size to the ad tag. Can be used multiple times per ad
 * addTargeting(key, value)     // add a key => value pair to the ad targeting. Can be used multiple times
 * setDelay(milliseconds)       // show the ad this many 'milliseconds' after it is loaded
 * setDeferred()                // Only show the ad when the 'smiDfp.loadDeferredAds()' function is called
 * setShowOnScroll()            // Only show the ad when it scrolls into view
 * setForceReload()             // If the 'smiDfp.refreshAds()' method is called, this ad will reload even if not in viewport
 * setNoReload()                // Prevents an ad from being reloaded by auto-reload
 * setSection(sectionName)      // If targeting a section other than 'smiDfp.defaultAdSection' for this specific ad, use this
 * setShowAdLite()              // This ad will still show, even if this user has chosen the 'Ad Light' experience
 * setShowAdFree()              // This ad will still show, even if this user has chosen the 'Ad Free' experience
 * render()                     // This outputs an HTML tag considering all options above, reday to be injected into the DOM
 * wrapWith(wrapper)            // Same as 'render()' but will append HTML tag into element created by smiDfp.buildAdWrapper()
 *
 * *** methods which control when the ad is displayed should not be combined (setDelay(), setDeferred(), setShowOnScroll()) ***
 * *** methods which control user experience should not be combined (setShowAdLite(), setShowAdFree()) ***
 *
 *
 * GLOBAL FUNCTIONS TO LOAD OR REFRESH ADS
 *
 * smiDfp.loadAds([optional]parentElement);     // processes ALL non-parsed ad tags (within parentElement if defined)
 * smiDfp.loadAd(el);                           // loads a specific ad by passing its ID
 * smiDfp.loadDeferredAds(el);                  // loads a deferred ad by passing its ID or all deferred ads within a parent [el]
 * smiDfp.refreshAds();                         // reloads all ads which are at least 50% in viewport or have forceReload() method applied
 *
 *
 * AD BUILDER CLASS
 *
 * Basic Example - 300x250 | displays in same location and same size on all devices
 *
 *   var ad, adHtml;
 *   ad = smiDfp.buildAd('phone,tablet,desktop');   // phone, tablet, desktop defined as breakpoints above
 *   ad.addSize(300, 250);                          // the ad is a 300x250 unit
 *   adHtml = ad.render();                          // this method compiles all 'ad.' directives into an HTML tag
 *
 *   $('.jQuery.element').html(adHtml);             // insert generated ad HTML into its parent element
 *   smiDfp.loadAds();                              // check entire HTML document for any unprocessed ad tags
 *
 * Intermediate Example - 300x250 mobile, 728x90 tablet & desktop with wrapper
 *
 *   var ad, adHtml, wrapper;
 *   wrapper = smiDfp.buildAdWrapper();             // build an element to wrap ads with (for spacing, border, background, etc.)
 *
 *   ad = smiDfp.buildAd('phone');                  // phone is a defined breakpoint from above
 *   ad.addSize(300, 250);                          // the ad is a 300x250 unit
 *   ad.wrapWith(wrapper);                          // automatically calls 'render()' method and appends HTML to 'wrapper'
 *
 *   ad = smiDfp.buildAd('tablet,desktop');         // tablet & desktop are defined breakpoints from above
 *   ad.addSize(728, 90);                           // the ad is a 728x90 unit
 *   ad.wrapWith(wrapper);                          // automatically calls 'render()' method and appends HTML to 'wrapper'
 *
 *   $('.jQuery.element').html(wrapper);            // insert 'wrapper' into its parent element
 *   smiDfp.loadAds('.jQuery.element');             // only look for unprocessed ad tags within $('.jQuery.element')
 *
 * Intermediate Example - no mobile ad, 728x90 tablet and 728x90 or 970x90 desktop with wrapper and a 4 second delay in loading using copy()
 *
 *   var ad, adHtml, wrapper;
 *   wrapper = smiDfp.buildAdWrapper();             // build an element to wrap ads with (for spacing, border, background, etc.)
 *
 *   ad = smiDfp.buildAd('tablet');                 // tablet is a defined breakpoint from above
 *   ad.setDelay(4000);                             // wait 4 seconds (4000 ms) to load this ad after the code is parsed
 *
 *   ad2 = smiDfp.copy(ad, 'desktop');              // copy above, but set as desktop
 *
 *   ad.addSize(728, 90);                           // 'ad' is a 728x90 unit
 *   ad.wrapWith(wrapper);                          // automatically calls 'render()' method and appends HTML to 'wrapper'
 *
 *   ad2.addSize(728, 90);                           // 'ad2' can be a 728x90 unit
 *   ad2.addSize(970, 90);                           // or it can be a 970x90 unit
 *   ad2.wrapWith(wrapper);                          // automatically calls 'render()' method and appends HTML to 'wrapper'
 *
 *   $('.jQuery.element').html(wrapper);            // insert 'wrapper' into its parent element
 *   smiDfp.loadAds('.jQuery.element');             // only look for unprocessed ad tags within $('.jQuery.element')
 *
 * Advanced Example - 728x90 or 970x90 desktop ad with MOST available methods (some can't be combined and will be covered individually)
 *
 *   var ad, adHtml;
 *
 *   ad = smiDfp.buildAd('desktop');                // desktop is a defined breakpoint from above
 *   ad.setSection('pd/entertainment');             // override the global ad section for just this ad
 *   ad.addSize(728, 90);                           // the ad can be a 728x90 unit
 *   ad.addSize(970, 90);                           // or it can be a 970x90 unit
 *   ad.addTargeting('position', 'ATF');            // add targeting parameters per ad services request
 *   ad.addTargeting('loc', 1);                     // add targeting parameters per ad services request
 *   ad.setDeferred();                              // do not load ad until manually told to do so
 *   ad.setForceReload();                           // reload this ad on request, even if not in viewport
 *   ad.setShowAdLite();                            // still show this ad, even if user has Ad Light experience
 *
 *   adHtml = ad.render();                          // return HTML tag containing relevant ad data
 *   $('#deferred-ad-parent').html(adHtml);         // Insert returned HTML into parent
 *
 *   *** At a time of your choosing (maybe a gallery slide comes into view) ***
 *   smiDfp.loadDeferredAds('#deferred-ad-parent'); // tell parent to look for deferred das and show them
 *
 */

var googletag = googletag || {};
googletag.cmd = googletag.cmd || [];

var loadAmazonAds = true;
var refreshVisibleAdsAfter = 35000; // 35 seconds

// @formatter:off
// https://developers.google.com/doubleclick-gpt/reference
/*(function() {
	var gads = document.createElement("script");
	gads.async = true;
	gads.type = "text/javascript";
	var useSSL = "https:" == document.location.protocol;
	gads.src = (useSSL ? "https:" : "http:") + "//securepubads.g.doubleclick.net/tag/js/gpt.js";
	var node = document.getElementsByTagName("script")[0];
	node.parentNode.insertBefore(gads, node);
})();*/

if(loadAmazonAds) {
	!function(a9,a,p,s,t,A,g){if(a[a9])return;function q(c,r){a[a9]._Q.push([c,r])}a[a9]={init:function(){q("i",arguments)},fetchBids:function(){q("f",arguments)},setDisplayBids:function(){},targetingKeys:function(){return[]},_Q:[]};A=p.createElement(s);A.async=!0;A.src=t;g=p.getElementsByTagName(s)[0];g.parentNode.insertBefore(A,g)}("apstag",window,document,"script","//c.amazon-adsystem.com/aax2/apstag.js");

	apstag.init({
		pubID: 'db83f9c6-a698-4a6a-89fb-c29c85426748',
		adServer: 'googletag',
		schain: {
			complete: 1,
			ver: '1.0',
			nodes: [
				{
					asi: 'yourbow.com',
					sid: '63',
					hp: 1,
				}
			]
		}
	});
}
// @formatter:on

if(typeof adSection === 'undefined') {
	var adSection = 'pd';
	console.warn('\'adSection\' is undefined. Failure to define this variable before loading dfploader.js will cause our ads to target to the default section.');
}

var smiDfp = {};
(function($) {
	'use strict';

	smiDfp.defaultAdSection = adSection;
	smiDfp.logging = 0;
	smiDfp.suppress = 0;
	if(document.location.search.indexOf('dfpDebug=1') !== -1 || document.location.search.indexOf('?dfpdeb') !== -1 || document.location.search.indexOf('&dfpdeb') !== -1)
		smiDfp.logging = 1;

	if(document.location.search.indexOf('suppressDfp=1') !== -1)
		smiDfp.suppress = 1;

	googletag.cmd.push(function() {
		googletag.pubads().set('adsense_background_color', 'FFFFFF');
		if(loadAmazonAds)
			googletag.pubads().disableInitialLoad();
		googletag.pubads().enableAsyncRendering();
		googletag.pubads().enableSingleRequest();
		googletag.pubads().collapseEmptyDivs(true);
		googletag.enableServices();

		googletag.pubads().addEventListener('slotRenderEnded', function(e) {
			var elementId = e.slot.getSlotElementId(),
				adHeight = $.isArray(e.size) && e.size[1] !== 'undefined' ? e.size[1] : 0,
				adWidth = $.isArray(e.size) && e.size[0] !== 'undefined' ? e.size[0] : 0,
				adOuter = $('#' + elementId),
				adSlot = adOuter.closest('.dfp-slot'),
				renderedTime = Date.now();

			if(adOuter.length && adSlot.length) {
				adSlot.data('last-rendered', renderedTime).attr('data-last-rendered', renderedTime).removeClass('dfp-refreshing');

				adSlot.addClass('dfp-rendered').css({minHeight: adHeight});

				//adSlot.trigger('dfpRendered', e);
				$(document).trigger('dfpRendered', [adSlot, e]);

				if(smiDfp.logging) console.log(' - ' + elementId + ' rendered');

				if(e.isEmpty) {
					if(smiDfp.logging) console.log('  - dfp reported slot is empty');
					adSlot.removeClass('dfp-rendered').css({minHeight: 0});
				}

				if(smiDfp.logging && e.isBackfill) console.log('  - dfp reported slot is backfill');

				if(smiDfp.logging && !e.slotContentChanged) console.log('  - dfp reported slot content did not change');
			}
		});
	});

	function onDfpLoaded(callback, iteration) {
		if(!iteration) iteration = 1;

		if(window.googletag && googletag.pubadsReady) {
			if($.isFunction(callback)) {
				callback.call(this);
			}
		} else {
			if(iteration++ <= 8) {
				setTimeout(function() {
					onDfpLoaded(callback, iteration);
				}, 250);
			}
		}
	}

	function isInViewport(el) {
		if(el instanceof $) el = el[0];

		var rect = typeof el.getBoundingClientRect === 'function' ? el.getBoundingClientRect() : null,
			vHeight = jQuery(window).height(),
			vWidth = jQuery(window).width();

		if(rect) {
			return (
				rect.top >= -(rect.height / 2) &&
				rect.left >= 0 &&
				rect.bottom <= vHeight + (rect.height / 2) &&
				rect.right <= vWidth
			);
		}
		return false;
	}

	smiDfp.renderedAds = [];
	smiDfp.foundKeywords = [];
	smiDfp.globalTargeting = {};

	function showAd(el, delay) {
		if(smiDfp.suppress) return;

		var size = el.data('size'),
			targeting = el.data('targeting'),
			adId = el.attr('id'),
			adSection = el.data('dfp'),
			adSectionFull, thisAd;

		if(adSection && typeof adSection !== undefined) {
			if(size && typeof size !== undefined) {
				var inner = $('<div />');

				el.addClass('dfp-rendering').html(inner);
				el.attr('id', '');
				inner.attr('id', adId);

				adSectionFull = '/94238257/' + adSection;
				thisAd = googletag.defineSlot(adSectionFull, size, adId);

				if(!$.isEmptyObject(smiDfp.globalTargeting)) {
					$.each(smiDfp.globalTargeting, function(k, v) {
						thisAd.setTargeting(k, v);
					});
				}

				if(smiDfp.foundKeywords.length) {
					thisAd.setTargeting('keyword', smiDfp.foundKeywords);
				}

				if(targeting && typeof targeting !== undefined) {
					$.each(targeting, function(k, v) {
						thisAd.setTargeting(k, v);
					});
				}

				var loadAmazonAdsIfEnabled = function() {
					if(loadAmazonAds) {
						apstag.fetchBids({
							slots  : [{
								slotID  : adId,
								slotName: adSectionFull,
								sizes   : size //example: [[300,250], [300,600]]
							}],
							timeout: 2e3
						}, function(bids) {
							googletag.cmd.push(function() {
								apstag.setDisplayBids();
								googletag.pubads().refresh([thisAd]);
							});
						});
					}
				};

				if($.isNumeric(delay)) {
					setTimeout(function() {
						if(smiDfp.logging) console.log('-- calling ' + adId);
						thisAd.addService(googletag.pubads());
						smiDfp.renderedAds[adId] = thisAd;
						googletag.display(adId);

						loadAmazonAdsIfEnabled();
					}, delay);
				} else {
					if(smiDfp.logging) console.log('-- calling ' + adId);
					thisAd.addService(googletag.pubads());
					smiDfp.renderedAds[adId] = thisAd;
					googletag.display(adId);

					loadAmazonAdsIfEnabled();
				}
			}
		} else {
			if(smiDfp.logging)
				console.log('Unable to render ads. An ad section needs to be defined globally using the variable \'smiDfp.defaultAdSection\'.');
		}
	}

	var deferredDfpAdCount = 1;

	function showDeferredAd(el) {
		googletag.cmd.push(function() {
			var deferredId = el.data('id') + '-d' + deferredDfpAdCount++;
			el.attr('data-deferred', 0).attr('id', deferredId);
			showAd(el);
		});
	}

	function showScrollToAd(el) {
		googletag.cmd.push(function() {
			el.data('onscroll', 0).attr('data-onscroll', 0);
			showAd(el);
		});
	}

	var adGroup = 0,
		dfpLoaderRunning = 0,
		dfpLoaderIteration = 0;

	smiDfp.loadAds = function(parentElement) {
		if(dfpLoaderRunning) {
			if(dfpLoaderIteration++ <= 50) {
				setTimeout(function() {
					smiDfp.loadAds(parentElement);
				}, 250);
			}
		} else {
			dfpLoaderIteration = 0;
			dfpLoaderRunning = 1;
			adGroup++;

			var $body = $('body'), $el;
			if(parentElement) $el = (typeof parentElement === 'string' || parentElement instanceof String) ? $(parentElement) : parentElement;
			else $el = $body;

			onDfpLoaded(function() {
				//$el.find(".dfp-slot:hidden").not("[data-deferred=1]").remove();

				if($body.hasClass('ad-lite')) {
					$el.find('.dfp-slot').not('.show-ad-lite').not('.show-ad-free').remove();
				}

				if($body.hasClass('ad-free')) {
					$el.find('.dfp-slot').not('.show-ad-free').remove();
				}

				$el.find('.dfp-wrap:empty').remove();

				var adTagsAvailable = $el.find('.dfp-slot').filter(':visible').not('.dfp-rendering');
				if(adTagsAvailable.length) {
					if(smiDfp.logging) console.log(adTagsAvailable.length + ' dfp slot(s) will be rendered');

					var adsToDisplay = adTagsAvailable.not('[data-deferred=1]').not('[data-onscroll=1]').not('[data-delayed]');
					if(smiDfp.logging && adsToDisplay.length) console.log('- ' + adsToDisplay.length + ' slot(s) will display immediately');

					var adsToDelay = adTagsAvailable.filter('[data-delayed]');
					if(smiDfp.logging && adsToDelay.length) console.log('- ' + adsToDelay.length + ' slot(s) will display with a delay');

					var adsToShowOnScroll = adTagsAvailable.filter('[data-onscroll=1]');
					if(smiDfp.logging && adsToShowOnScroll.length) console.log('- ' + adsToShowOnScroll.length + ' slot(s) will be lazy loaded');

					var deferredAds = adTagsAvailable.filter('[data-deferred=1]');
					if(smiDfp.logging && deferredAds.length) console.log('- ' + deferredAds.length + ' slot(s) will display when triggered');

					if(!$.isEmptyObject(smiDfp.globalTargeting)) {
						if(smiDfp.logging) {
							console.log('-- the following \'key => value\' pairs will be added to the targeting of all ads:');
							$.each(smiDfp.globalTargeting, function(k, v) {
								console.log(' - ' + k + ' => ' + v);
							});
						}
					}

					if(keywords && keywordSelectors) {
						if(smiDfp.logging)
							console.log('-- looking for keywords [' + keywords.join(', ') + '] in selectors [' + keywordSelectors.join(', ') + ']');

						$.each(keywordSelectors, function(s, selector) {
							var text = $el.find(selector).text().toLowerCase();
							if(text.length > 100) {
								if(smiDfp.logging)
									console.log(' - Text Length: ' + text.length);

								$.each(keywords, function(k, keyword) {
									var kw, pos;
									kw = keyword.toLowerCase();
									pos = text.indexOf(kw);
									if(pos > 10) {
										if(smiDfp.logging)
											console.log(' - Keyword \'' + keyword + '\' found at ' + pos);

										if(smiDfp.foundKeywords.indexOf(keyword) === -1)
											smiDfp.foundKeywords.push(keyword);
									} else {
										if(smiDfp.logging)
											console.log(' - Keyword \'' + keyword + '\' not found');
									}
								});
							}
						});
					}

					if(adsToDisplay.length || adsToDelay.length) {
						googletag.cmd.push(function() {
							$.each(adsToDisplay.add(adsToDelay), function() {
								var adTag = $(this),
									delay = adTag.data('delayed');

								showAd(adTag, delay);
							});
						});
					}

					var adsNotCurrentlyInView = [];
					if(adsToShowOnScroll.length) {
						$.each(adsToShowOnScroll, function() {
							if(isInViewport($(this))) {
								showScrollToAd($(this));
							} else {
								adsNotCurrentlyInView.push($(this));
							}
						});
					}

					if(adsNotCurrentlyInView.length) {
						var scrollEvent = 'scroll.smidfp.delayed.' + adGroup,
							hasScrolled = false,
							scrollInterval;

						$(window).on(scrollEvent, function() {
							hasScrolled = true;
						});

						scrollInterval = setInterval(function() {
							if(hasScrolled) {
								hasScrolled = false;
								var onscrollAds = adTagsAvailable.filter('[data-onscroll=1]');
								if(onscrollAds.length) {
									$.each(onscrollAds, function() {
										if(isInViewport($(this))) {
											showScrollToAd($(this));
										}
									});
								} else {
									$(window).off(scrollEvent);
									clearInterval(scrollInterval);
								}
							}
						}, 350);
					}

				}
				dfpLoaderRunning = 0;
			});
		}
	};

	smiDfp.loadAd = function(el) {
		googletag.cmd.push(function() {
			el = (typeof el === 'string' || el instanceof String) ? $(el) : el;
			showAd(el);
		});
	};

	smiDfp.loadDeferredAds = function(el) {
		el = (typeof el === 'string' || el instanceof String) ? $(el) : el;

		//el.find(".dfp-slot[data-deferred=1]:hidden").remove();
		//el.find(".dfp-wrap:empty").remove();

		var element = el.find('.dfp-slot[data-deferred=1]:visible');
		if(!element.length) {
			//el.filter(".dfp-slot[data-deferred=1]:hidden").remove();
			//el.filter(".dfp-wrap:empty").remove();
			element = el.filter('[data-deferred=1]');
		}

		if(element.length) {
			$.each(element, function() {
				showDeferredAd($(this));
			});
		}
	};

	smiDfp.refreshAds = function() {
		onDfpLoaded(function() {
			var adSlots = $('.dfp-slot').filter(':visible').not('[data-deferred=1]'),
				adOuter, adElement, forceReload;
			if(adSlots.length) {
				$.each(adSlots, function() {
					adOuter = $(this);
					adElement = $(this).find('div:first');
					forceReload = adOuter.data('force-reload');
					if(isInViewport(adOuter) || (forceReload && forceReload !== 'undefined')) {
						smiDfp.refreshAd(adOuter, true);
					}
				});
			}
		});
	};

	smiDfp.refreshVisibleAds = function() {
		onDfpLoaded(function() {
			if(refreshVisibleAdsAfter && !pageIsIdle) {
				$('.dfp-slot[data-last-rendered]:visible').not('.dfp-refreshing').not('.dfp-no-reload').filter(function() {
					var dfpSlot = $(this),
						lastRendered = dfpSlot.data('last-rendered') || 0,
						refreshAfter = (lastRendered + refreshVisibleAdsAfter);
					return isInViewport(dfpSlot) && (refreshAfter < Date.now());
				}).each(function() {
					smiDfp.refreshAd($(this));
				});
			}
		});
	};

	smiDfp.refreshAd = function(dfpSlot, ignoreTimer) {
		var lastRendered = dfpSlot.data('last-rendered') || 0,
			isRefreshing = dfpSlot.hasClass('dfp-refreshing'),
			refreshAfter = (lastRendered + refreshVisibleAdsAfter),
			refreshAds = !!refreshVisibleAdsAfter,
			adElement, adElementId;

		if(!refreshAds) return;

		if(isRefreshing) return;

		if(!ignoreTimer && Date.now() < refreshAfter) return;

		adElementId = dfpSlot.find('div:first').attr('id') || false;
		adElement = smiDfp.renderedAds[adElementId] || false;

		if(adElement && adElementId) {
			if(smiDfp.logging) console.log('refreshing ' + adElementId);
			dfpSlot.addClass('dfp-refreshing');
			googletag.pubads().refresh([adElement], {changeCorrelator: false});
		}
	};

	smiDfp.addGlobalTargeting = function(key, value) {
		smiDfp.globalTargeting[key] = value;
	};

	var adCount = 0,
		breakpoints = [],
		keywords = [],
		keywordSelectors = [];

	var _createClass = function() {
		function defineProperties(target, props) {
			for(var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if('value' in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		return function(Constructor, protoProps, staticProps) {
			if(protoProps) defineProperties(Constructor.prototype, protoProps);
			if(staticProps) defineProperties(Constructor, staticProps);
			return Constructor;
		};
	}();

	function _classCallCheck(instance, Constructor) {
		if(!(instance instanceof Constructor)) {
			throw new TypeError('Cannot call a class as a function');
		}
	}

	var adBuilder = function() {
		function adBuilder(visibleFor, cssClass, style, tag) {
			_classCallCheck(this, adBuilder);

			this.showAdLite = 0;
			this.showAdFree = 0;
			this.delayed = 0;
			this.deferred = 0;
			this.showOnScroll = 0;
			this.forceReload = 0;
			this.noReload = 0;
			this.sizes = [];
			this.attributes = {};
			this.targeting = {};
			this.visibleFor = visibleFor;
			this.class = cssClass;
			this.style = style;
			if(!tag) tag = 'div';
			this.tag = tag;
			this.section = smiDfp.defaultAdSection;
			this.id = 'ad-' + adCount++;
		}

		_createClass(adBuilder, [{
			key  : 'addSize',
			value: function addSize(width, height) {
				this.sizes.push({width: width, height: height});
				return this;
			}
		}, {
			key  : 'addAttribute',
			value: function addAttribute(key, value) {
				this.attributes[key] = value;
				return this;
			}
		}, {
			key  : 'addTargeting',
			value: function addTargeting(key, value) {
				this.targeting[key] = value;
				return this;
			}
		}, {
			key  : 'setDelay',
			value: function setDelay(milliseconds) {
				this.delayed = milliseconds;
				return this;
			}
		}, {
			key  : 'setDeferred',
			value: function setDeferred() {
				this.deferred = true;
				return this;
			}
		}, {
			key  : 'setShowOnScroll',
			value: function setShowOnScroll() {
				this.showOnScroll = true;
				return this;
			}
		}, {
			key  : 'setForceReload',
			value: function setForceReload() {
				this.forceReload = true;
				return this;
			}
		}, {
			key  : 'setNoReload',
			value: function setNoReload() {
				this.noReload = true;
				return this;
			}
		}, {
			key  : 'setSection',
			value: function setSection(newSection) {
				this.section = newSection;
				return this;
			}
		}, {
			key  : 'setShowAdLite',
			value: function setShowAdLite() {
				this.showAdLite = true;
				return this;
			}
		}, {
			key  : 'setShowAdFree',
			value: function setShowAdFree() {
				this.showAdFree = true;
				return this;
			}
		}, {
			key  : 'render',
			value: function render() {
				if(this.visibleFor && this.sizes.length) {
					var tag = $('<' + this.tag + ' />'),
						firstSize = this.sizes[0],
						sizes = [];

					this.id += '-' + firstSize.width + 'x' + firstSize.height;
					if(this.deferred) {
						tag.attr('data-deferred', 1);
					} else {
						if(this.showOnScroll) {
							tag.attr('data-onscroll', 1);
						} else if(this.delayed) {
							tag.attr('data-delayed', this.delayed);
						}
					}

					tag.addClass('dfp-slot').attr('data-dfp', this.section);

					if(this.class) tag.addClass(this.class);
					if(this.style) tag.attr('style', this.style);
					if(this.forceReload) tag.attr('data-force-reload', 1);
					if(this.noReload) tag.addClass('dfp-no-reload');
					if(this.showAdLite) tag.addClass('show-ad-lite');
					if(this.showAdFree) tag.addClass('show-ad-free');

					$.each(this.sizes, function(i, v) {
						sizes.push([v.width, v.height]);
					});

					if(sizes.length === 1) {
						tag.attr('data-size', JSON.stringify(sizes[0]));
					} else {
						tag.attr('data-size', JSON.stringify(sizes));
					}

					if(Object.getOwnPropertyNames(this.attributes).length) {
						$.each(this.attributes, function(attribute, value) {
							tag.attr(attribute, value);
						});
					}

					if(Object.getOwnPropertyNames(this.targeting).length) {
						tag.attr('data-targeting', JSON.stringify(this.targeting));
					}

					var theTags = [],
						theId = this.id,
						isDeferred = this.deferred;

					$.each(this.visibleFor.split(','), function(i, visibleFor) {
						var thisTag = tag.clone(true),
							thisId = theId + '-' + visibleFor;
						thisTag.addClass('dfp-slot-' + visibleFor);
						if(isDeferred) {
							thisTag.attr('data-id', thisId);
						} else {
							thisTag.attr('id', thisId);
						}
						theTags.push(thisTag);
					});

					return theTags;
				}
				return false;
			}
		}, {
			key  : 'wrapWith',
			value: function wrapWith(wrapper) {
				var tag = this.render();
				wrapper.append(tag);
			}
		}], [{
			key  : 'copy',
			value: function copy(ad, visibleFor) {
				var ad2 = ad;
				ad2.visibleFor = visibleFor ? visibleFor : ad.visibleFor;
				ad2.id = 'ad-' + adCount++ + '-' + ad2.visibleFor.replace(/\,/g, '-');
				return ad2;
			}
		}, {
			key  : 'buildAdShim',
			value: function buildAdShim(visibleFor, height, width, tag) {
				if(!width) width = '100%';
				if(!tag) tag = 'div';
				tag = $('<' + tag + ' />', {
					'class': 'dfp-slot',
					'style': 'height:' + height + ';width:' + width + ';'
				});
				visibleFor = visibleFor.split(',');
				$.each(visibleFor, function(i, v) {
					tag.addClass('dfp-slot-' + v);
				});
				return tag;
			}
		}, {
			key  : 'buildAdWrap',
			value: function buildAdWrap(cssClass, style, tag) {
				if(!tag) tag = 'div';
				var wrap = $('<' + tag + ' />', {'class': 'dfp-wrap'});
				if(cssClass) wrap.addClass(cssClass);
				if(style) wrap.attr('style', style);
				return wrap;
			}
		}, {
			key  : 'addKeyword',
			value: function addKeyword(keyword) {
				keywords.push(keyword);
				return this;
			}
		}, {
			key  : 'addKeywordSelector',
			value: function addKeywordSelector(selector) {
				keywordSelectors.push(selector);
				return this;
			}
		}, {
			key  : 'addBreakpoint',
			value: function addBreakpoint(name, minWidth, maxWidth, buildCss) {
				breakpoints.push({
					'name'    : name,
					'minWidth': minWidth,
					'maxWidth': maxWidth
				});
				buildCss = buildCss !== undefined ? buildCss : true;
				if(buildCss) this.renderBreakpointCSS();
			}
		}, {
			key  : 'renderBreakpointCSS',
			value: function renderBreakpointCSS() {
				var tag = $('style#dfp-breakpoint-css'),
					style = void 0;

				if(!tag.length) {
					tag = $('<style id="dfp-breakpoint-css" type="text/css" />').appendTo('head');
				}

				style = '.dfp-slot, .dfp-wrap { display: block; text-align: center; }';
				style += '.ad-lite .dfp-slot, .ad-free .dfp-slot { display: none; }';
				style += '.ad-lite .dfp-slot.show-ad-lite, .ad-lite .dfp-slot.show-ad-free, .ad-free .dfp-slot.show-ad-free { display: block; }';
				$.each(breakpoints, function(i, v) {
					var min, max;
					if(!v.minWidth && v.maxWidth) {
						max = $.isNumeric(v.maxWidth) ? (v.maxWidth + 1) + 'px' : v.maxWidth;
						style += '@media screen and (min-width: ' + max + ') {';
						style += '.dfp-slot-' + v.name + ' { display: none !important; }';
						style += '}';
					} else if(v.minWidth && !v.maxWidth) {
						min = $.isNumeric(v.minWidth) ? (v.minWidth - 1) + 'px' : v.minWidth;
						style += '@media screen and (max-width: ' + min + ') {';
						style += '.dfp-slot-' + v.name + ' { display: none !important; }';
						style += '}';
					} else if(v.minWidth && v.maxWidth) {
						min = $.isNumeric(v.minWidth) ? (v.minWidth - 1) + 'px' : v.minWidth;
						max = $.isNumeric(v.maxWidth) ? (v.maxWidth + 1) + 'px' : v.maxWidth;
						style += '@media screen and (max-width: ' + min + ') {';
						style += '.dfp-slot-' + v.name + ' { display: none !important; }';
						style += '}';
						style += '@media screen and (min-width: ' + max + ') {';
						style += '.dfp-slot-' + v.name + ' { display: none !important; }';
						style += '}';
					}
				});
				tag.html(style);
			}
		}]);

		return adBuilder;
	}();

	smiDfp.buildAd = function(visibleFor, cssClass, style, tag) {
		return new adBuilder(visibleFor, cssClass, style, tag);
	};

	smiDfp.copy = function(ad, visibleFor) {
		return adBuilder.copy(ad, visibleFor);
	};

	smiDfp.buildAdWrapper = function(cssClass, style, tag) {
		return adBuilder.buildAdWrap(cssClass, style, tag);
	};

	smiDfp.buildAdShim = function(visibleFor, height, width, tag) {
		return adBuilder.buildAdShim(visibleFor, height, width, tag);
	};

	smiDfp.addKeyword = function(keyword) {
		adBuilder.addKeyword(keyword);
	};

	smiDfp.addKeywordSelector = function(selector) {
		adBuilder.addKeywordSelector(selector);
	};

	smiDfp.addBreakpoint = function(name, minWidth, maxWidth, buildCss) {
		adBuilder.addBreakpoint(name, minWidth, maxWidth, buildCss);
	};

	smiDfp.setAdLite = function() {
		$('body').addClass('ad-lite');
	};

	smiDfp.unsetAdLite = function() {
		$('body').removeClass('ad-lite');
	};

	smiDfp.setAdFree = function() {
		$('body').addClass('ad-free');
	};

	smiDfp.unsetAdFree = function() {
		$('body').removeClass('ad-free');
	};

	smiDfp.buildCubeAd = function(el, breakpoints, targeting, delay, className) {
		delay = delay ? delay : 500;

		var cubeAd = smiDfp.buildAd(breakpoints, className);
		cubeAd.addSize(300, 250);
		if(delay) cubeAd.setDelay(delay);
		if(targeting) {
			$.each(JSON.parse(targeting), function(key, value) {
				cubeAd.addTargeting(key, value);
			});
		}

		$(el).html(cubeAd.render());
	}

	var resizeTimer; // debounced
	$(window).on('resize orientationchange', function() {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function() {
			smiDfp.loadAds();
		}, 350);
	});

	var hasScrolled = false,
		pageIsIdle = true,
		pageIdleTimer;
	$(window).on('scroll.dfpLoader', function() {
		hasScrolled = true;
	});

	setInterval(function() {
		if(hasScrolled) {
			pageIsIdle = false;
			hasScrolled = false;
			smiDfp.refreshVisibleAds();

			clearTimeout(pageIdleTimer);
			pageIdleTimer = setTimeout(function() {
				pageIsIdle = true;
			}, 60000);
		}
	}, 500);

	setInterval(function() {
		smiDfp.refreshVisibleAds();
	}, 5000);

	window.addEventListener('message', function(event) {
		if(event.data === 'dfpIsRichMedia') {
			var adId = event.source.frameElement.id;
			jQuery(function($) {
				$('[id="' + adId + '"]').closest('.dfp-slot').addClass('dfp-no-reload');
			});
		}
	}, false);
})(jQuery);
const cphHost = window.location.hostname;
var cphPD, cphSIT, cphPAC, cphNBBJ, cphSCG, cphLPS, cphDomain, cphCookieDomain, cphNlHost, cphPubName, cphPubAbbrev, cphFeedDir, cphEnv;

cphCookieDomain = cphHost;
(function() {
	var pdHosts = ['www.pressdemocrat.com', 'stage.pressdemocrat.com', 'site.stage.ew.srp.navigacloud.com', 'site.everywarestarterkit.local'];
	var sitHosts = ['www.sonomanews.com', 'stage.sonomanews.com', 'sit.stage.ew.srp.navigacloud.com', 'sit.everywarestarterkit.local'];
	var pacHosts = ['www.petaluma360.com', 'stage.petaluma360.com', 'pac.stage.ew.srp.navigacloud.com', 'pac.everywarestarterkit.local'];
	var nbbjHosts = ['www.northbaybusinessjournal.com', 'stage.northbaybusinessjournal.com', 'nbbj.stage.ew.srp.navigacloud.com', 'nbbj.everywarestarterkit.local'];
	var scgHosts = ['www.sonomacountygazette.com', 'stage.sonomacountygazette.com', 'scg.stage.ew.srp.navigacloud.com', 'scg.everywarestarterkit.local'];
	var lpsHosts = ['www.laprensasonoma.com', 'stage.laprensasonoma.com', 'lps.prod.ew.srp.navigacloud.com', 'lps.stage.ew.srp.navigacloud.com', 'lps.everywarestarterkit.local'];

	if(sitHosts.indexOf(cphHost) !== -1) {
		cphSIT = true;
		cphDomain = "sonomanews.com";
		cphPubName = "Sonoma Index-Tribune";
		cphPubAbbrev = "sit";
		cphFeedDir = "sit2018";
	} else if(pacHosts.indexOf(cphHost) !== -1) {
		cphPAC = true;
		cphDomain = "petaluma360.com";
		cphPubName = "Petaluma Argus-Courier";
		cphPubAbbrev = "pac";
		cphFeedDir = "pac2018";
	} else if(nbbjHosts.indexOf(cphHost) !== -1) {
		cphNBBJ = true;
		cphDomain = "northbaybusinessjournal.com";
		cphPubName = "North Bay Business Journal";
		cphPubAbbrev = "nbbj";
		cphFeedDir = "nbbj2018";
	} else if(scgHosts.indexOf(cphHost) !== -1) {
		cphSCG = true;
		cphDomain = "sonomacountygazette.com";
		cphPubName = "Sonoma County Gazette";
		cphPubAbbrev = "scg";
		cphFeedDir = "scg2018";
	} else if(lpsHosts.indexOf(cphHost) !== -1) {
		cphLPS = true;
		cphDomain = "laprensasonoma.com";
		cphPubName = "La Prensa Sonoma";
		cphPubAbbrev = "lps";
		cphFeedDir = "lps2018";
	} else {
		cphPD = true;
		cphDomain = "pressdemocrat.com";
		cphPubName = "Press Democrat";
		cphPubAbbrev = "pd";
		cphFeedDir = "pd2018";
	}

	cphNlHost = 'https://newsletter.' + cphDomain;

	var cookieDomainParts = cphCookieDomain.split('.');
	var topLevel = cookieDomainParts.shift();
	if(topLevel === 'www' || topLevel === 'navweb') // remove www only if top-level
		cphCookieDomain = '.' + cookieDomainParts.join('.');
})();

if(cphHost.indexOf('stage.') === 0 || cphHost.indexOf('everywarestarterkit.local') !== -1) {
	cphEnv = 'test';
} else {
	cphEnv = 'prod';
}

// @formatter:off
/*
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
(function(b,c){var $=b.jQuery||b.Cowboy||(b.Cowboy={}),a;$.throttle=a=function(e,f,j,i){var h,d=0;if(typeof f!=="boolean"){i=j;j=f;f=c}function g(){var o=this,m=+new Date()-d,n=arguments;function l(){d=+new Date();j.apply(o,n)}function k(){h=c}if(i&&!h){l()}h&&clearTimeout(h);if(i===c&&m>e){l()}else{if(f!==true){h=setTimeout(i?k:l,i===c?e-m:e)}}}if($.guid){g.guid=j.guid=j.guid||$.guid++}return g};$.debounce=function(d,e,f){return f===c?a(d,e,false):a(d,f,e!==false)}})(this);
// @formatter:on


// CHECK FOR ACTIVE NOTIFICATIONS ON DOM READY
if(!cphSCG && !cphLPS) {
	jQuery(function($) {
		var isPreview = cphGlobal.getQueryStringValueByKey('notiPreview') === 'true',
			getVersion = isPreview ? 'preview' : 'live',
			cacheTicks = isPreview ? Math.random() : Math.floor(new Date().getMinutes() / 5); // re-cache every 5 minutes if not preview version

		$.getJSON('https://api.pressdemocrat.com/_data/notifications/' + cphPubAbbrev + '-' + getVersion + '.json?cache=' + cacheTicks).done(function(data) {
			if(data.length) {
				$.each(data, function(i, v) {
					cphGlobal.buildNotification(v.id, v.type, v.position, v.priority, v.html, v.closeFor, v.hideIcon);
				});
			}
		});
	});
}


// CHECK FOR EXISTENCE OF div#fast-breaking AND REQUEST DATA IF PRESENT
// disabled 2022-08-09 due to non-use. Would rather build a JS embed
/*if(cphPD) {
	jQuery(function($) {
		var fastBreaking = $('#fast-breaking:visible');
		if(!fastBreaking.length) return; // exit function if div not present or hidden

		var cacheTicks = Math.floor(new Date().getMinutes() / 5); // re-cache every 5 minutes
		$.get('https://breaking.pressdemocrat.com/breaking.html?cache=' + cacheTicks).done(function(html) {
			if(html.length > 50) {
				fastBreaking.addClass('containerXXX').html(html);
			}
		});
	});
}*/

// CHECK AND UPDATE WEATHER ICON AND TEMP IN HEADER
jQuery(function($) {
	var wxDiv = $('#header-weather:visible');
	if(!wxDiv.length) return; // exit function if div not present or hidden

	var cacheTicks = Math.floor(new Date().getMinutes() / 5); // re-cache every 5 minutes

	$.getJSON('https://feeds.' + cphDomain + '/' + cphFeedDir + '/wex/feed.json?cache=' + cacheTicks).done(function(data) {
		var iconNum = data[0].WeatherIcon,
			iconTemp = data[0].Temperature.Imperial.Value;
		wxDiv.removeClass().addClass('icon-' + iconNum).find('.label').text(iconTemp + '°');
	});
});

// MAKE HEADER STICKY WHEN USER SCROLLS UP, THEN HIDE AGAIN WHEN SCROLLING DOWN
jQuery(function($) {
	cphLoader.loadThrottleDebounce(function() {
		var body = $('body'),
			header = $('#header'),
			lastScroll = window.scrollY,
			thisScroll = lastScroll;

		$(window).on('scroll', $.throttle(250, function() {
			thisScroll = window.scrollY;
			if(thisScroll >= 100 && thisScroll < lastScroll) {
				body.addClass('fixed-header');
				header.slideDown(180);
			} else {
				if(thisScroll < 100) {
					header.show();
					body.removeClass('fixed-header');
				} else {
					header.slideUp(90, function() {
						body.removeClass('fixed-header');
					});
				}
			}
			lastScroll = thisScroll;
		}));
	});
});

// BUILD HEADER / MASTHEAD / MULTILEVEL MENUS
jQuery(function($) {
	var menus = $('.multi-level-menu'),
		hasChildren = false;

	$.each(menus, function(menu) {
		var uls = $(this).is('ul') ? $(this) : $(this).children('ul');

		$.each(uls, function() {
			var topLevels = $(this);
			topLevels.children('li').addClass('top-level');
			topLevels.find('ul').each(function(level) {
				hasChildren = true;

				var ul = $(this),
					li = ul.closest('li'),
					toggle = $('<span class="sub-menu-toggle"></span>');
				li.addClass('has-sub-menu').append(toggle);

				toggle.click(function() {
					if(li.hasClass('sub-menu-visible')) {
						li.removeClass('sub-menu-visible').find('.sub-menu-visible').removeClass('sub-menu-visible');
					} else {
						var thisParents = li.parentsUntil(topLevels[level], 'li.sub-menu-visible');
						$(menus[menu]).find('.sub-menu-visible').not(thisParents).each(function() {
							$(this).removeClass('sub-menu-visible');
						});

						if(li.is('.top-level')) {
							var liMid = li.offset().left + (li.outerWidth() / 2),
								sideClass = liMid > ($(window).width() / 2) ? 'menu-left' : 'menu-right';
							li.removeClass('menu-left menu-right').addClass(sideClass);
						}
						li.addClass('sub-menu-visible');
					}
				});
			});
		});
		$(document).on('closeChildMenus', function(e, originalEvent) {
			if($(originalEvent.target).closest(uls).length)
				return;

			$(menus[menu]).find('.sub-menu-visible').removeClass('sub-menu-visible');
		});
	});
	if(hasChildren) {
		$(document.body).click(function(e) {
			$(document).trigger('closeChildMenus', e);
		});
	}
});

// HANDLE TOGGLING OF SEARCH INPUT
jQuery(function($) {
	$('#search-toggle').on('click', function() {
		$('#header-search').toggleClass('opened');
	});
});

// HANDLE BUILDING AND TOGGLING OF PUSH MENU
jQuery(function($) {
	var body = $('body'),
		menu = $('#push-menu'),
		menuToggle = $('#push-menu-toggle, #lps-push-menu-toggle, #scg-push-menu-toggle');

	menuToggle.on('click', function(e) {
		e.preventDefault();

		// todo: if complaints about push menu, lose if and use else only
		if((typeof CSS === 'object') && CSS.supports('transition: transform .45s') && CSS.supports('transform: translateX(0)')) {
			body.addClass('push-menu-left-showing');
			menu.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
				$(document).one('click', '.push-menu-left-showing #push-menu-overlay, .push-menu-left-showing .push-menu-close', function() {
					body.addClass('push-menu-left-hiding').removeClass('push-menu-left-showing');
					menu.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
						body.removeClass('push-menu-left-hiding');
						closeActiveSubmenus();
					});
				});
			});
		} else {
			body.addClass('push-menu-left-showing');
			$(document).one('click', '.push-menu-left-showing #push-menu-overlay, .push-menu-left-showing .push-menu-close', function() {
				body.addClass('push-menu-left-hiding').removeClass('push-menu-left-showing');
				setTimeout(function() {
					body.removeClass('push-menu-left-hiding');
					closeActiveSubmenus();
				}, 450);
			});
		}
	});

	menu.find('ul ul').closest('li').each(function() {
		var li = $(this),
			ul = li.children('ul'),
			toggle = $('<span class="sub-menu-toggle"></span>');

		li.prepend(toggle);

		toggle.click(function() {
			var thisParents = li.parentsUntil(ul, 'li.sub-menu-visible');
			if(li.hasClass('sub-menu-visible')) {
				closeActiveSubmenus(thisParents);
			} else {
				closeActiveSubmenus(thisParents);
				ul.slideDown(350, function() {
					li.addClass('sub-menu-visible');
				});
			}
		});
	});

	function closeActiveSubmenus(toSkip) {
		toSkip = toSkip || {};

		var lis = menu.find('.sub-menu-visible');
		if(lis.length) {
			$.each(lis, function() {
				var li = $(this);
				li.not(toSkip).children('ul').slideUp(350, function() {
					li.removeClass('sub-menu-visible');
				});
			});
		}
	}
});

// LAZYLOAD IMAGES IF IN OR ABOVE THE CURRENT VIEWPORT
jQuery(function($) {
	var wait; // throttled every 250ms
	$(window).on('load scroll', function() {
		if(!wait) {
			wait = true;
			setTimeout(function() {
				wait = false;
				$('.lazyload[data-src]').not('.loading, .loaded').each(function() {
					var image = $(this);
					if(isAboveBottomOfViewport(image)) {
						var src = image.data('src'),
							srcset = image.data('srcset'),
							sizes = image.data('sizes');

						image.removeAttr('data-src').removeAttr('data-srcset').removeAttr('data-sizes').addClass('loading').css({opacity : 0, transition : 'opacity 180ms'});
						image.on('load', function() {
							image.removeClass('lazyload loading').addClass('loaded').css({opacity : 1});
						});
						image.attr('src', src).attr('srcset', srcset).attr('sizes', sizes);
					}
				});
			}, 250);
		}
	});

	$(window).trigger('scroll');

	function isAboveBottomOfViewport(el) {
		el = (typeof el === 'string' || el instanceof String) ? $(el) : el;
		var elementTop = el.offset().top,
			viewportTop = $(window).scrollTop(),
			viewportBottom = viewportTop + $(window).height();
		return elementTop < viewportBottom;
	}
});

var cphGlobal = {};

cphGlobal.isProd = function() {
	return cphEnv === 'prod';
};


cphGlobal.isStage = function() {
	return cphEnv === 'test';
};

cphGlobal.hasLocalStorage = function() {
	if(typeof cphGlobal.localStorageChecked !== 'boolean') {
		var mod = 'localStorageCheck';
		try {
			localStorage.setItem(mod, mod);
			localStorage.removeItem(mod);
			cphGlobal.localStorageChecked = true;
		} catch(e) {
			cphGlobal.localStorageChecked = false;
		}
	}
	return cphGlobal.localStorageChecked;
};

cphGlobal.hasSessionStorage = function() {
	if(typeof cphGlobal.sessionStorageChecked !== 'boolean') {
		var mod = 'sessionStorageCheck';
		try {
			sessionStorage.setItem(mod, mod);
			sessionStorage.removeItem(mod);
			cphGlobal.sessionStorageChecked = true;
		} catch(e) {
			cphGlobal.sessionStorageChecked = false;
		}
	}
	return cphGlobal.sessionStorageChecked;
};

(function($) {
	cphGlobal.hasFloatedObstacle = function(el, parent) {
		if(!parent) parent = el.parent();

		var widthCheck = $('<div/>', {style: 'display: block; margin: 0; padding: 0; height: 0; overflow: hidden;'}),
			elWidth;

		widthCheck.insertBefore(el);
		elWidth = widthCheck.width();

		widthCheck.remove();

		return elWidth !== parent.width();
	};

	cphGlobal.hasCcpaCookieValue = function(value, cookieName) {
		if(!cookieName) cookieName = 'ccpaPrefs';
		var ccpaCookie = decodeURIComponent(cphGlobal.getCookieByName(cookieName));
		if(ccpaCookie && ccpaCookie.length) {
			var values = ccpaCookie.split(/\s*,\s*/);
			return values.indexOf(value) !== -1;
		}
		return false;
	};

	cphGlobal.buildNotification = function(id, type, position, priority, html, closeFor, hideIcon) {
		if(!cphGlobal.getCookieByName(id) || cphGlobal.getQueryStringValueByKey('notiPreview') === 'true') {
			var inner = $('<div />').addClass('notification-container').html(html),
				container = $('<div />', {'class' : 'padded container', 'html' : inner}),
				wrap = $('<div />', {'class' : 'notification ' + type, 'id' : id, 'html' : container}),
				hasButton = wrap.find('button, .button');

			if(!hideIcon) wrap.addClass('has-icon');

			if(hasButton.length) wrap.addClass('has-button');

			if(closeFor !== 'na') {
				var close = $('<span />', {'class' : 'notification-close'}).prependTo(wrap),
					altClose = wrap.find('[data-action=close]'),
					days = closeFor,
					date, expires;

				if($.isNumeric(days)) {
					date = new Date();
					date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
					expires = '; expires=' + date.toGMTString();
				} else {
					expires = '';
				}

				close.one('click', function() {
					document.cookie = id + '=1' + expires + '; path=/';
					wrap.slideUp(180, function() {
						$(this).remove();
					});
				});

				if(altClose.length) {
					close.hide();
					altClose.click(function() {
						close.trigger('click');
					});
				}
			}

			if(position === 'top') {
				$('#top-notifications').append(wrap);
			} else if(position === 'bottom') {
				$('#bottom-notifications').append(wrap);
			}
		}
	};

	cphGlobal.wrapWithFigure = function(element, caption) {
		var figure = $('<figure>', {
			html : $('<div>', {
				class : 'pd-figure-outer-wrap',
				html  : $('<div>', {
					class : 'pd-figure-inner-wrap',
					html  : element
				})
			})
		});
		if(caption && caption !== 'undefined') {
			$('<figcaption>', {
				html : $('<div>', {
					class : 'pd-figcaption-inner-wrap',
					html  : caption
				})
			}).appendTo(figure);
		}
		return figure;
	};

	cphGlobal.wrapFigures = function(figures, size, position) {
		return $('<div>', {
			class : 'pd-shortcode-widget',
			html  : figures
		}).addClass('pd-widget-size-' + size).addClass('pd-widget-position-' + position);
	};

	cphGlobal.getQueryStringValueByKey = function(key, url) {
		if(!url) url = window.location.href;
		key = key.replace(/[\[\]]/g, '\\$&');
		var regex = new RegExp('[?&]' + key + '(=([^&#]*)|&|#|$)'),
			results = regex.exec(url);
		if(!results) return null;
		if(!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
	};

	cphGlobal.updateQueryStringParameter = function(key, value, url) {
		if(!url) url = window.location.href;

		var i = url.indexOf('#');
		var hash = i === -1 ? '' : url.substr(i);
		url = i === -1 ? url : url.substr(0, i);

		var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
		var separator = url.indexOf('?') !== -1 ? '&' : '?';
		if(value === false) { // added if(value === false) as a means to remove a parameter by setting cphGlobal.updateQueryStringParameter("key",
			// false)
			if(url.match(re)) {
				url = url.replace(re, '$1');
			}
		} else {
			if(url.match(re)) {
				url = url.replace(re, '$1' + key + '=' + value + '$2');
			} else {
				url = url + separator + key + '=' + value;
			}
		}
		url = url.replace(/([\?\&]+)$/, ''); // added to remove ? or & at end of url if present
		return url + hash;
	};

	cphGlobal.exitIntent = function(callback, activeAfter, intentAfter) {
		activeAfter = (activeAfter) ? parseInt(activeAfter) : 5000;
		intentAfter = (intentAfter) ? parseInt(intentAfter) : 350;

		if(typeof callback === 'function') {
			cphGlobal.exitIntentTrigger = setTimeout(function() {
				var exitTimer;
				$(document).on('mouseout.cphExitIntent', function(e) {
					if(!$(e.toElement).length && e.relatedTarget === null) {
						clearTimeout(cphGlobal.exitIntentTrigger);
						exitTimer = setTimeout(function() {
							$(document).off('.cphExitIntent');
							callback.call();
						}, intentAfter); // give 350ms to get back in bounds
					} else {
						clearTimeout(exitTimer);
					}
				});
			}, activeAfter); // have user on page for at least 5 seconds before this can be triggered
		}
	};

	cphGlobal.replaceUrl = function(newUrl) {
		history.replaceState({}, '', newUrl);
	};

	cphGlobal.cookiesEnabled = function() {
		try {
			document.cookie = 'cookietest=1';
			var ret = document.cookie.indexOf('cookietest=') !== -1;
			document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
			return ret;
		} catch(e) {
			return false;
		}
	};

	cphGlobal.setCookie = function(name, value, days) {
		var expires;
		if(days) {
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = ';expires=' + date.toUTCString();
		} else {
			expires = '';
		}
		document.cookie = name + '=' + value + expires + ';path=/;domain=' + cphCookieDomain;
	};

	cphGlobal.getCookie = function(name) {
		function escape(s) {
			return s.replace(/([.*+?\^${}()|\[\]\/\\])/g, '\\$1');
		}

		var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
		return match ? match[1] : null;
	};

	cphGlobal.getCookieByName = function(name) {
		// alias for legacy purposes
		return cphGlobal.getCookie(name);
	};

	cphGlobal.deleteCookie = function(name) {
		document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=' + cphCookieDomain;
	};

	cphGlobal.getEmail = function() {
		return cphGlobal.getCookieByName('auth_email') || cphGlobal.getCookieByName(cphPubAbbrev + '_email') || cphGlobal.getCookieByName('nl_email');
	};

	cphGlobal.isBetweenDates = function(startDate, endDate) {
		var date_switch_on = new Date(startDate),
			date_switch_off = endDate ? new Date(endDate) : false,
			date_now = new Date(),
			time_switch_on = date_switch_on.getTime(),
			time_switch_off = date_switch_off ? date_switch_off.getTime() : false,
			time_now = date_now.getTime();

		return (time_switch_off && time_now > time_switch_on && time_now < time_switch_off) || (!time_switch_off && time_now > time_switch_on);
	};

	cphGlobal.addUTM = function(url, source, medium, campaign, content) {
		if(source)
			url = cphGlobal.updateQueryStringParameter('utm_source', encodeURIComponent(source), url);
		if(medium)
			url = cphGlobal.updateQueryStringParameter('utm_medium', encodeURIComponent(medium), url);
		if(campaign)
			url = cphGlobal.updateQueryStringParameter('utm_campaign', encodeURIComponent(campaign), url);
		if(content)
			url = cphGlobal.updateQueryStringParameter('utm_content', encodeURIComponent(content), url);

		return url;
	};

	cphGlobal.removeUTM = function(url) {
		url = cphGlobal.updateQueryStringParameter('utm_source', false, url);
		url = cphGlobal.updateQueryStringParameter('utm_medium', false, url);
		url = cphGlobal.updateQueryStringParameter('utm_campaign', false, url);
		url = cphGlobal.updateQueryStringParameter('utm_content', false, url);
		url = cphGlobal.updateQueryStringParameter('utm_email', false, url);

		return url;
	};

	cphGlobal.toSlug = function(str) {
		return str.toLowerCase().replace(/[^a-z0-9]/g, '-').replace(/(\-)+/g, '-').replace(/^(\-)+/g, '').replace(/(\-)+$/g, '');
	};

	cphGlobal.toSnakeCase = function(str) {
		str = cphGlobal.toSlug(str);
		return str.replace(/(\-)+/g, '_');
	};

	cphGlobal.toCamelCase = function(str) {
		str = cphGlobal.toSlug(str);
		return str.replace(/(\-[a-z0-9])/g, function($1) {
			return $1.toUpperCase().replace('-', '');
		});
	};

	// @formatter:off
	cphGlobal.md5 = function(n){function r(n,r){var t=n[0],f=n[1],i=n[2],a=n[3];f=c(f=c(f=c(f=c(f=e(f=e(f=e(f=e(f=o(f=o(f=o(f=o(f=u(f=u(f=u(f=u(f,i=u(i,a=u(a,t=u(t,f,i,a,r[0],7,-680876936),f,i,r[1],12,-389564586),t,f,r[2],17,606105819),a,t,r[3],22,-1044525330),i=u(i,a=u(a,t=u(t,f,i,a,r[4],7,-176418897),f,i,r[5],12,1200080426),t,f,r[6],17,-1473231341),a,t,r[7],22,-45705983),i=u(i,a=u(a,t=u(t,f,i,a,r[8],7,1770035416),f,i,r[9],12,-1958414417),t,f,r[10],17,-42063),a,t,r[11],22,-1990404162),i=u(i,a=u(a,t=u(t,f,i,a,r[12],7,1804603682),f,i,r[13],12,-40341101),t,f,r[14],17,-1502002290),a,t,r[15],22,1236535329),i=o(i,a=o(a,t=o(t,f,i,a,r[1],5,-165796510),f,i,r[6],9,-1069501632),t,f,r[11],14,643717713),a,t,r[0],20,-373897302),i=o(i,a=o(a,t=o(t,f,i,a,r[5],5,-701558691),f,i,r[10],9,38016083),t,f,r[15],14,-660478335),a,t,r[4],20,-405537848),i=o(i,a=o(a,t=o(t,f,i,a,r[9],5,568446438),f,i,r[14],9,-1019803690),t,f,r[3],14,-187363961),a,t,r[8],20,1163531501),i=o(i,a=o(a,t=o(t,f,i,a,r[13],5,-1444681467),f,i,r[2],9,-51403784),t,f,r[7],14,1735328473),a,t,r[12],20,-1926607734),i=e(i,a=e(a,t=e(t,f,i,a,r[5],4,-378558),f,i,r[8],11,-2022574463),t,f,r[11],16,1839030562),a,t,r[14],23,-35309556),i=e(i,a=e(a,t=e(t,f,i,a,r[1],4,-1530992060),f,i,r[4],11,1272893353),t,f,r[7],16,-155497632),a,t,r[10],23,-1094730640),i=e(i,a=e(a,t=e(t,f,i,a,r[13],4,681279174),f,i,r[0],11,-358537222),t,f,r[3],16,-722521979),a,t,r[6],23,76029189),i=e(i,a=e(a,t=e(t,f,i,a,r[9],4,-640364487),f,i,r[12],11,-421815835),t,f,r[15],16,530742520),a,t,r[2],23,-995338651),i=c(i,a=c(a,t=c(t,f,i,a,r[0],6,-198630844),f,i,r[7],10,1126891415),t,f,r[14],15,-1416354905),a,t,r[5],21,-57434055),i=c(i,a=c(a,t=c(t,f,i,a,r[12],6,1700485571),f,i,r[3],10,-1894986606),t,f,r[10],15,-1051523),a,t,r[1],21,-2054922799),i=c(i,a=c(a,t=c(t,f,i,a,r[8],6,1873313359),f,i,r[15],10,-30611744),t,f,r[6],15,-1560198380),a,t,r[13],21,1309151649),i=c(i,a=c(a,t=c(t,f,i,a,r[4],6,-145523070),f,i,r[11],10,-1120210379),t,f,r[2],15,718787259),a,t,r[9],21,-343485551),n[0]=d(t,n[0]),n[1]=d(f,n[1]),n[2]=d(i,n[2]),n[3]=d(a,n[3])}function t(n,r,t,u,o,e){return r=d(d(r,n),d(u,e)),d(r<<o|r>>>32-o,t)}function u(n,r,u,o,e,c,f){return t(r&u|~r&o,n,r,e,c,f)}function o(n,r,u,o,e,c,f){return t(r&o|u&~o,n,r,e,c,f)}function e(n,r,u,o,e,c,f){return t(r^u^o,n,r,e,c,f)}function c(n,r,u,o,e,c,f){return t(u^(r|~o),n,r,e,c,f)}function f(n){var r,t=[];for(r=0;r<64;r+=4)t[r>>2]=n.charCodeAt(r)+(n.charCodeAt(r+1)<<8)+(n.charCodeAt(r+2)<<16)+(n.charCodeAt(r+3)<<24);return t}var i="0123456789abcdef".split("");function a(n){for(var r="",t=0;t<4;t++)r+=i[n>>8*t+4&15]+i[n>>8*t&15];return r}function h(n){return function(n){for(var r=0;r<n.length;r++)n[r]=a(n[r]);return n.join("")}(function(n){txt="";var t,u=n.length,o=[1732584193,-271733879,-1732584194,271733878];for(t=64;t<=n.length;t+=64)r(o,f(n.substring(t-64,t)));n=n.substring(t-64);var e=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];for(t=0;t<n.length;t++)e[t>>2]|=n.charCodeAt(t)<<(t%4<<3);if(e[t>>2]|=128<<(t%4<<3),t>55)for(r(o,e),t=0;t<16;t++)e[t]=0;return e[14]=8*u,r(o,e),o}(n))}function d(n,r){return n+r&4294967295}if("5d41402abc4b2a76b9719d911017c592"!=h("hello"))function d(n,r){var t=(65535&n)+(65535&r);return(n>>16)+(r>>16)+(t>>16)<<16|65535&t}return h(n)};
	// @formatter:on
})(jQuery);

var cphLoader = {};
(function($) {
	var scriptBeingLoaded = [], scriptIsLoaded = [];

	cphLoader.checkIfScriptLoaded = function(name, src, callback, firstLoadCallback) {
		scriptBeingLoaded[name] = (scriptBeingLoaded[name] === "undefined") ? null : scriptBeingLoaded[name];
		scriptIsLoaded[name] = (scriptIsLoaded[name] === "undefined") ? null : scriptIsLoaded[name];

		if(scriptBeingLoaded[name] && !scriptIsLoaded[name]) {
			setTimeout(function() {
				cphLoader.checkIfScriptLoaded(name, src, callback);
			}, 250);
		} else {
			scriptBeingLoaded[name] = true;
			var methods = name.split("."),
				functionName = window;

			for(var i in methods) {
				functionName = functionName[methods[i]];
			}

			if(typeof functionName === "undefined") {
				var getScript = $.ajax({
					type: 'GET',
					url: src,
					dataType: 'script',
					cache: true
				});

				getScript.done(function(script, textStatus, jqxhr) {
					console.log(name + " loaded");
					if(jqxhr.status < 400) {
						if($.isFunction(firstLoadCallback)) {
							firstLoadCallback.call(this);
						}
						if($.isFunction(callback)) {
							scriptIsLoaded[name] = true;
							callback.call(this);
						}
					}
				});

				getScript.always(function() {
					scriptBeingLoaded[name] = false;
				});
			} else {
				if($.isFunction(callback)) {
					callback.call(this);
				}
			}
		}
	};

	cphLoader.checkIfStyleLoaded = function(id, src) {
		if(!$("#" + id).length) {
			$("<link/>", {
				id   : id,
				rel  : "stylesheet",
				type : "text/css",
				href : src
			}).appendTo("head");
		}
	};

	cphLoader.loadSwiper = function(callback) {
		cphLoader.checkIfStyleLoaded("swiper-css", "https://cdnjs.cloudflare.com/ajax/libs/Swiper/6.5.8/swiper-bundle.min.css");
		cphLoader.checkIfScriptLoaded("Swiper", "https://cdnjs.cloudflare.com/ajax/libs/Swiper/6.5.8/swiper-bundle.min.js", callback);
	};

	cphLoader.loadTableSorter = function(callback) {
		$(function() {
			// https://mottie.github.io/tablesorter/docs/index.html
			cphLoader.checkIfStyleLoaded('tablesorter-css', 'https://cdnjs.cloudflare.com/ajax/libs/jquery.tablesorter/2.31.3/css/theme.default.min.css');
			cphLoader.checkIfScriptLoaded('jQuery.fn.tablesorter', 'https://cdnjs.cloudflare.com/ajax/libs/jquery.tablesorter/2.31.3/js/jquery.tablesorter.combined.min.js', callback);
		});
	};

	cphLoader.loadLazySizes = function(callback) {
		cphLoader.checkIfScriptLoaded("lazySizes", "https://cdnjs.cloudflare.com/ajax/libs/lazysizes/4.0.1/lazysizes.min.js", callback);
	};

	cphLoader.loadThrottleDebounce = function(callback) {
		//no longer making external call for this script. Now at top of base.js
		//cphLoader.checkIfScriptLoaded("jQuery.throttle", "https://cdnjs.cloudflare.com/ajax/libs/jquery-throttle-debounce/1.1/jquery.ba-throttle-debounce.js", callback);
		if($.isFunction(callback)) {
			callback.call(this);
		}
	};

	cphLoader.loadFlatpickr = function(callback, rangePlugin, theme) {
		if(!rangePlugin) rangePlugin = false;
		if(!theme) theme = "airbnb"; // airbnb, confetti, dark, light, material_blue, material_green, material_orange, material_red
		cphLoader.checkIfStyleLoaded("flatpickr-css", "//cdnjs.cloudflare.com/ajax/libs/flatpickr/4.5.2/flatpickr.min.css");
		cphLoader.checkIfStyleLoaded("flatpickr-theme-" + theme + "-css", "//cdnjs.cloudflare.com/ajax/libs/flatpickr/4.5.2/themes/" + theme + ".css");
		cphLoader.checkIfScriptLoaded("flatpickr", "//cdnjs.cloudflare.com/ajax/libs/flatpickr/4.5.2/flatpickr.min.js", function() {
			if(rangePlugin) {
				cphLoader.checkIfScriptLoaded("rangePlugin", "//cdnjs.cloudflare.com/ajax/libs/flatpickr/4.5.2/plugins/rangePlugin.js", callback);
			}
		});
	};

	cphLoader.loadSoundcite = function(callback) {
		cphLoader.checkIfStyleLoaded("soundcite-css", "https://cdn.knightlab.com/libs/soundcite/latest/css/player.css");
		cphLoader.checkIfScriptLoaded("soundciteLoader", "https://cdn.knightlab.com/libs/soundcite/latest/js/soundcite.min.js", callback);
		window.soundciteLoader = true; // because the script does not use a globally scoped function, I can't tell if it has been loaded.
	};

	cphLoader.loadTipped = function(callback) {
		cphLoader.checkIfStyleLoaded("tipped-css", "https://cdn.pressdemocrat.com/vendor/tipped/4.7.0/tipped.css");
		cphLoader.checkIfScriptLoaded("Tipped", "https://cdn.pressdemocrat.com/vendor/tipped/4.7.0/tipped.js", callback);
	};

	cphLoader.loadPdfObject = function(callback) {
		cphLoader.checkIfScriptLoaded("PDFObject", "//cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.js", callback);
	};

	cphLoader.loadCphLightbox = function(callback) {
		//cphLoader.checkIfScriptLoaded("cphLightbox", "https://code.pressdemocrat.com/shared/2020/vendor/cph/lightbox/3.0.2/lightbox.min.js", callback);
		cphLoader.checkIfScriptLoaded("cphLightbox", "https://cdn.pressdemocrat.com/vendor/cph/lightbox/3.0.4/lightbox.min.js", callback);
	};

	cphLoader.loadCphGallery = function(callback) {
		cphLoader.loadSwiper(function() {
			//cphLoader.checkIfScriptLoaded("cphGallery", "https://code.pressdemocrat.com/shared/2020/vendor/cph/gallery/1.0.0/gallery.min.js", callback);
			cphLoader.checkIfScriptLoaded("cphGallery", "https://cdn.pressdemocrat.com/vendor/cph/gallery/1.0.1/gallery.min.js", callback);
		});
	};

	cphLoader.loadSortable = function(callback) {
		cphLoader.checkIfScriptLoaded('Sortable', 'https://cdnjs.cloudflare.com/ajax/libs/Sortable/1.13.0/Sortable.min.js', callback);
	};
})(jQuery);

(function($) {
	$.fn.isInViewport = function() {
		var elementTop = $(this).offset().top;
		var elementBottom = elementTop + $(this).outerHeight();

		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();

		return elementBottom > viewportTop && elementTop < viewportBottom;
	};
})(jQuery);
let ga4Tags = {};
ga4Tags['smi'] = 'G-84Q5ST7BN6';
ga4Tags['site'] = null;
ga4Tags['paywall'] = null;

switch(cphPubAbbrev) {
    case 'pd' :
        ga4Tags['site'] = 'G-1V71J0RS5C';
        ga4Tags['paywall'] = 'G-Q3RYZ35K41';
        break;
    case 'sit' :
        ga4Tags['site'] = 'G-K5E335ZW0Z';
        ga4Tags['paywall'] = 'G-K2KZ2GWN99';
        break;
    case 'pac' :
        ga4Tags['site'] = 'G-80KN4D1J3G';
        ga4Tags['paywall'] = 'G-9V23XZQZFC';
        break;
    case 'nbbj' :
        ga4Tags['site'] = 'G-F5RJL13SPW';
        break;
    case 'scg' :
        ga4Tags['site'] = 'G-9NTV5449WZ';
        break;
    case 'lps' :
        ga4Tags['site'] = 'G-TCR7Z2E57D';
        break;
}

window.dataLayer = window.dataLayer || [];

if(ga4Tags.site) {
    (function() {
        const head = document.getElementsByTagName('head')[0];
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=' + ga4Tags.site;
        head.appendChild(script);
    })();

    function gtag() {dataLayer.push(arguments);}

    gtag('js', new Date());

    gtag('config', ga4Tags.site, {
        'groups'        : 'always',
        'send_page_view': false
    });

    if(ga4Tags.smi) {
        gtag('config', ga4Tags.smi, {
            'groups'        : 'always',
            'send_page_view': false
        });
    }

    if(ga4Tags.paywall) {
        gtag('config', ga4Tags.paywall, {
            'groups'        : 'paywall',
            'send_page_view': false
        });
    }
}

jQuery(function($) {
    const ga4Type = window.pageType || '';
    const ga4Sections = window.pageSections || [];
    const ga4Topics = window.pageTags || [];
    const ga4Mg2PageData = window.mg2PageData || {};

    gtag('event', 'page_view', {
        'sections'  : ga4Sections,
        'topics'    : ga4Topics,
        'page_type' : ga4Type,
        'is_metered': ga4Mg2PageData.metered || 0,
        'is_premium': ga4Mg2PageData.premium || 0,
        'send_to'   : 'always'
    });

    ga4Sections.forEach(function(section) {
        gtag('event', 'section', {
            'section_name': section,
            'send_to'     : 'always'
        });
    });

    ga4Topics.forEach(function(topic) {
        gtag('event', 'topic', {
            'topic_name': topic,
            'send_to'   : 'always'
        });
    });

    $(document).on('smi:gallerySlide', function() {
        const slideNum = parseInt(cphGlobal.getQueryStringValueByKey('artslide') || -1) + 1;
        gtag('event', 'page_view', {
            'gallery_slide'    : true,
            'gallery_slide_num': slideNum,
            'send_to'          : 'always'
        });

        gtag('event', 'gallery', {
            'gallery_slide'    : true,
            'gallery_slide_num': slideNum,
            'send_to'          : 'always'
        });

        ga4Sections.forEach(function(section) {
            gtag('event', 'section', {
                'section_name' : section,
                'gallery_slide': true,
                'send_to'      : 'always'
            });
        });

        ga4Topics.forEach(function(topic) {
            gtag('event', 'topic', {
                'topic_name'   : topic,
                'gallery_slide': true,
                'send_to'      : 'always'
            });
        });
    });

    $(document).on('smi:paywallShown', function() {
        if(ga4Tags.paywall) {
            gtag('event', 'page_view', {
                'paywall_shown': true,
                'is_premium'   : ga4Mg2PageData.premium || 0,
                'send_to'      : 'paywall'
            });
        }

        gtag('event', 'paywall', {
            'paywall_shown': true,
            'is_premium'   : ga4Mg2PageData.premium || 0,
            'send_to'      : 'always'
        });
    });

    $(document).on('smi:ajaxPageView', function() {
        gtag('event', 'page_view', {
            'is_ajax': true,
            'send_to': 'always'
        });
    });
});

jQuery(function($) {
    $(document).on('dfpRendered', function(e, adSlot, origEvent) {
        if($(adSlot).closest('.pw-adhesion-wrap').length) {
            $('#pw-adhesion-button-wrap').remove();
            if(origEvent.isEmpty)
                return;

            setTimeout(function() {
                // display the pw-adhesion-close button (x) &#215;
                var close = $('<div id="pw-adhesion-button-wrap"><span id="pw-adhesion-button-close" title="Close Ad">&#215;</span></div>');

                var adIframe = $('.pw-adhesion-wrap iframe:first:visible');
                adIframe.before(close);
                var width = adIframe.attr( 'width' );

                $('#pw-adhesion-button-wrap').css('max-width', width + 'px');

                $('#pw-adhesion-button-wrap span').click(function () {
                    $('.pw-adhesion-wrap').slideToggle("slow");
                });
            }, 15000);
        }
    });
});

/*jQuery(function($) {
    $('body').append('<div class="s2nPlayer k-atlpCxHi" data-type="float"></div><script type="text/javascript" src="//embed.sendtonews.com/player3/embedcode.js?fk=atlpCxHi&cid=5649&offsetx=0&offsety=0&floatwidth=400&floatposition=bottom-right" data-type="s2nScript"></script>');
});*/
/*jQuery(function($) {
    var menu = $('#menu-contact-help');
    if(!menu.length) return;

    var cookiePrefs = $('<li><a href="javascript:void(0)">Cookie Preferences</a></li>'),
        doNotSell = $('<li><a href="#">Do Not Sell My Personal Info</a></li>'),
        privacyUrl = siteConfig.url.privacy || false;

    menu.append(cookiePrefs);

    cookiePrefs.find('a').click(function() {
        $(document).trigger('loadCCPAwindow');
    });

    if(privacyUrl) {
        doNotSell.find('a').attr('href', privacyUrl + '/policy/#do-not-sell');
        menu.append(doNotSell);
    }
});*/
// OVERWRITE PD PLUS ICON WITH VERSION THAT HAS TOOLTIP
jQuery(function($) {
    var plusIcon = $('<span/>', {
        class: 'tier-icon',
        title: 'Premium content, available to subscribers only.'
    });

    var breakingFreeIcon = $('<span/>', {
        class: 'tier-icon',
        title: 'Essential news for the community - free from the ' + cphPubName + '.'
    });

    var hasVideoIcon = $('<span/>', {
        class: 'tier-icon no-tooltip'
    });

    $(document).on('tpl:blockLoaded', function(e, block) {
        block = $(block);

        var tierIcons = block.find('[data-tier="plus"], [data-tier="breaking-free"], [data-tier="has-video"]').find('.story-heading h3, .tpl2022__headline h3');

        tierIcons.each(function() {
            var headline = $(this);
            if(!headline.hasClass('has-tier-icon')) {
                if(headline.closest('[data-tier="plus"]').length) {
                    headline.find('.tier-icon').remove();
                    headline.prepend(plusIcon.clone());
                    loadTippedDeferred();
                } else if(headline.closest('[data-tier="breaking-free"]').length) {
                    headline.find('.tier-icon').remove();
                    headline.prepend(breakingFreeIcon.clone());
                    loadTippedDeferred();
                } else if(headline.closest('[data-tier="has-video"]').length) {
                    headline.find('.tier-icon').remove();
                    headline.prepend(hasVideoIcon.clone());
                    loadTippedDeferred();
                }

                // always add .has-tier-icon class so it stops trying
                headline.addClass('has-tier-icon');
            }
        });
    });

    $('a[href*="/premium/"]').each(function() {
        var link = $(this),
            path;

        if(link.closest('[data-tier="plus"]').length) return;
        if(link.find('> img').length) return;

        path = new URL(link.attr('href')).pathname || '';

        if(path.startsWith('/premium') || path.startsWith('/article/premium')) {
            if(!link.hasClass('has-tier-icon')) {
                link.prepend(plusIcon.clone()).attr('data-tier', 'plus').addClass('has-tier-icon');
                loadTippedDeferred();
            }
        }
    });

    var tippedDeferredLoaded = false;

    function loadTippedDeferred() {
        if(!tippedDeferredLoaded) {
            tippedDeferredLoaded = true;
            cphLoader.loadTipped(function() {
                Tipped.delegate('.tier-icon:not(".no-tooltip")', {
                    position: 'topleft',
                    offset  : {
                        y: -5
                    },
                    behavior: 'hide',
                    maxWidth: 250,
                    size    : 'large'
                });
            });
        }
    }
});

// MG2 AUTHENTICATION, PAYWALL AND NEWSLETTER HANDLERS
// https://github.com/mg2connext/connext/wiki/dev
jQuery(function($) {
    var loggedOutMenu = $('#MG2logged-out-menu'),
        activateMenu = $('#MG2activate-menu'),
        loggedInMenu = $('#MG2logged-in-menu'),
        mSubscribeButton = $('#account-subscribe-mobile');

    var emailCookieName = cphPubAbbrev + '_email',
        isSubscribed = cphGlobal.getCookieByName('IsSubscriber'),
        isInternal = (cphGlobal.getCookieByName('userType') === 'internal'),
        hasEmail, mg2Email;

    if(cphGlobal.cookiesEnabled() && !cphGlobal.getCookieByName('userType')) {
        cphGlobal.setCookie('userType', 'user');
        $.getJSON('https://code.pressdemocrat.com/getip/index.php', function(data) {
            if(typeof data.ip !== 'undefined') {
                var smiIps = [
                    '198.29.255.8', // Mendo Ave.
                    //'70.36.192.178', // unknown
                    //'96.74.120.25', // unknown
                    '192.184.221.146', // B St.
                    '38.142.246.82', // SIT
                    '75.101.41.82' // RP
                    // '73.92.214.79' // CPH Home
                ];

                //var proQuestMatches = /^165\.215/;
                if(smiIps.indexOf(data.ip) !== -1) {
                    cphGlobal.setCookie('userType', 'internal', 7);
                    location.reload();
                } /*else if(data.ip.match(proQuestMatches)) {
                    cphGlobal.setCookie('userType', 'internal', 7);
                    location.reload();
                } */
            }
        });
    }

    var addPaywallBlur = function() {
        $('.pw-section:not(:first) > *, .pw-section:first > *:not(.mark-text)').addClass('blurry-text');

        $('.pw-section .pd-shortcode-widget, .main-gallery, .related-stories, .related-stories-bs').addClass('pw-blur');

        $('.fact-box, .hide-on-paywall').addClass('pw-hide');

        $('body').addClass('has-pw');
    };

    var removePaywallBlur = function() {
        $('.blurry-text, .pw-blur, .pw-hide, .has-pwb').removeClass('blurry-text pw-blur pw-hide');
        $('body').removeClass('has-pw');
    };

    $(document).on('onNewsletterSignUp', function(e) {
        try {
            var nlEmail = $.trim(e.detail.EventData.Email.toLowerCase());
            if(nlEmail) cphGlobal.setCookie('nl_email', nlEmail, 365);
        } catch(e) {
            console.log('email not set by onNewsletterSignUp event');
        }
    });

    $(document).on('removePaywallBlur', function() {
        removePaywallBlur();
    });

    $(document).on('onPaywallShown', function(e) {
        // push onPaywallShown event to GTM dataLayer to trigger Paywall pageview
        if(typeof dataLayer === 'object') dataLayer.push({'event': 'onPaywallShown'});

        // remove MG2 styles that collapse/hide any embeds within article
        $('style.content-styles.mark-text').remove();

        addPaywallBlur();
    });

    $(document).on('click', '.mg2-logout', function(e) {
        e.preventDefault();
        Connext.Logout();
        cphGlobal.deleteCookie('userType');
        doNotSubscribed();
        $(document).trigger('mg2LoggedOut');
        Connext.Run();
    });

    function doLoggedIn() {
        $('#internal-login').remove();
        if(typeof Connext.Storage.GetUserData === 'function') {
            var mg2User = Connext.Storage.GetUserData();
            if(typeof mg2User.Email === 'string') {
                mg2Email = $.trim(mg2User.Email.toLowerCase());
                hasEmail = $.trim(cphGlobal.getCookieByName(emailCookieName)).toLowerCase();

                if(mg2Email && (!hasEmail || mg2Email !== hasEmail)) {
                    cphGlobal.setCookie(emailCookieName, mg2Email, 30);
                    doSubscribed();
                    return;
                }
            }
        }
        doSubscribed();
    }

    function doSubscribed() {
        $('body').addClass('circ-subscribed');
        hasEmail = $.trim(cphGlobal.getCookieByName(emailCookieName)).toLowerCase();
        isSubscribed = cphGlobal.getCookieByName('IsSubscriber');

        if(isSubscribed !== 'True') {
            cphGlobal.setCookie('IsSubscriber', 'True', 30);
            //if(cphGlobal.cookiesEnabled() && !isInternal) {
                //location.reload(); // reload on initial pageload.
                // disabled 2022-11-20 because it was causing refresh loop in Chrome.
            //}
        }

        $(document).trigger('mg2:loggedIn', {email: mg2Email});

        loggedOutMenu.add(activateMenu).add(mSubscribeButton).addClass('hide');
        loggedInMenu.removeClass('hide');

        $('#gravatar').attr('src', 'https://www.gravatar.com/avatar/' + cphGlobal.md5(hasEmail) + '?s=50&d=mp');

        removePaywallBlur();

        var emailLine = $('#logged-in-email');
        if(hasEmail.length) {
            if(emailLine.length) {
                emailLine.text(hasEmail);
            } else {
                $('<li />', {
                    'id'   : 'logged-in-email',
                    'class': 'email-heading',
                    text   : hasEmail
                }).prependTo(loggedInMenu.find('ul:first'));
            }
        } else {
            emailLine.remove();
        }
    }

    function doNotSubscribed() {
        if(isInternal) {
            $(document).trigger('hasInternalAccess');
        } else {
            $('body').removeClass('circ-subscribed');
            $('#internal-login').remove();
            cphGlobal.deleteCookie('IsSubscriber');
            cphGlobal.deleteCookie(emailCookieName);
        }
    }

    if(isSubscribed === 'True') {
        doSubscribed();
    }

    /** INTERNAL ACCESS HANDLER - ONLY GETS FIRED IF WITHIN SMI IP ADDRESS **/
    $(document).on('hasInternalAccess', function() {
        if(isInternal) {
            if(!$('#internal-login').length) {
                $('<li/>', {
                    html: $('<a/>', {
                        id               : 'internal-login',
                        href             : '#',
                        text             : 'Change Log In',
                        'data-mg2-action': 'login'
                    })
                }).appendTo(loggedInMenu.find('ul:first'));
            }

            cphGlobal.setCookie(emailCookieName, 'info@' + cphDomain);
            doSubscribed();
        }
    });

    /** MG2 AUTHENTICATION HANDLERS **/
    $(document).on('onHasAccess', function(e) {
        doLoggedIn();
    });

    $(document).on('onNotAuthorized', function(e) {
        loggedInMenu.add(activateMenu).addClass('hide');
        loggedOutMenu.add(mSubscribeButton).removeClass('hide');
        doNotSubscribed();
    });

    $(document).on('onAuthorized onHasNoActiveSubscription onHasAccessNotEntitled', function(e) {
        loggedInMenu.add(loggedOutMenu).addClass('hide');
        activateMenu.add(mSubscribeButton).removeClass('hide');
        doNotSubscribed();
    });
});
//jQuery(function($) {
	/*$(document).on('featuredBlockLoaded', function(e, block) {
		if(block.data('path') === 'pd/home/featured') {
			$('<div/>', {
				style : 'margin-bottom: .65em;',
				html : '<strong>Have a coronavirus story to share?</strong> Let us know at <a href="mailto:coronavirus@pressdemocrat.com"><em>coronavirus@pressdemocrat.com</em></a>'
			}).prependTo(block.find('.featured-stories'));
		}
	});*/

	/*if(!cphNBBJ && cphGlobal.getCookieByName('IsSubscriber') !== 'True') {
		var freeAccesss = 'https://www.pressdemocrat.com/multimedia/10868198-181/thanks-for-your-support';
		if(cphSIT) {
			freeAccesss = 'https://www.sonomanews.com/multimedia/10870920-181/thanks-for-your-support';
		} else if(cphPAC) {
			freeAccesss = 'https://www.petaluma360.com/multimedia/10870918-181/thanks-for-your-support';
		}

		cphGlobal.buildNotification('cv2', 'success', 'top', 1, 'We are providing <a href="' + freeAccesss + '">free access</a> to local public health stories to help prevent the spread of the coronavirus. Please support local journalism by <a href="/subscribe/">subscribing today</a>.', 1, true);
	}*/
//});



if(cphPD && cphGlobal.isBetweenDates('2022-12-12 00:00:01', '2022-12-16 23:59:59')) {
	jQuery(function($) {
		$('.account-menu .red.button').html('Sale $2 for<br>2 months').attr('style', 'display:inline-flex;align-items:center;line-height:1.2;background-color:#B58734;color:#000000 !important');

		$('#account-subscribe-mobile').text('Sale').attr('style', 'margin-left:.65em;background-color:#B58734;color:#000000 !important');
	});
}


var smiPromoOffer = 'none'; // oneweeksale
/*if(cphGlobal.isBetweenDates("2019-11-29 00:00:01", "2019-12-06 16:00:00")) {
	smiPromoOffer = 'oneweeksale';
}*/

(function() {
	function checkJaimeTest() {
		if(cphGlobal.getQueryStringValueByKey('jaimeTest') === 'on') {
			cphGlobal.setCookie('jaimeTest', 1);
		} else if(cphGlobal.getQueryStringValueByKey('jaimeTest') === 'off') {
			cphGlobal.deleteCookie('jaimeTest');
		}

		if(cphGlobal.getCookieByName('jaimeTest')) {
			//smiPromoOffer = 'oneweeksale';
			jQuery(function($) {
				var url = cphGlobal.updateQueryStringParameter('jaimeTest', 'off');

				$('<div />', {
					style : 'position: fixed; bottom: 0; right: 0; padding: .15em .5em; background: rgba(255, 64, 0, .8); color: white; z-index: 50;',
					html  : 'Testing <a href="' + url + '"><u>STOP</u></a>'
				}).appendTo('body');
			});
		}
	}
	checkJaimeTest();
})();

(function($) {
	// FOR MATHER: pass user email to SMAG if identified on PD
	if(cphPD) {
		$(document).on('mouseup contextmenu click', 'a', function() {
			var link = $(this),
				href = link.attr('href'),
				emailValue = $.trim(cphGlobal.getCookieByName('pd_email')).toLowerCase();

			emailValue = (emailValue === 'info@pressdemocrat.com') ? null : emailValue;
			if(emailValue && href.indexOf('sonomamag.com') !== -1 && href.indexOf('utm_id=') === -1) {
				href = cphGlobal.updateQueryStringParameter('utm_id', btoa(emailValue), href);
				link.attr('href', href);
			}
		});
	}
})(jQuery);

// USED IN CONNEXT TO DETERMINE WHICH COOKIE MATHER HAS SET
function getMIPC() {
	var d = 11, c, cv, v, i;
	c = document.cookie.match('(^|;)\\s*_matherSegments\\s*=\\s*([^;]+)');
	cv = c ? c.pop() : false;
	if(cv) {
		v = cv.split(',');
		for(i = 0; i < v.length; i++) {
			var dm = v[i].match(/MATHER_U9_INSTANTMET(2|4|6|8|11)_20191201/);
			if(dm) {
				d = dm.pop();
				break;
			}
		}
	}
	return parseInt(d);
}

/*
(function($) {
	$(document).on('tpl:blockLoaded', function(e, block) {
		block = $(block);

		if(block.is('[data-template="a1-pd"]')) {
			var impact = block.find('.story-0'),
				modDate = impact.data('mod-display'),
				description = impact.find('.story-description');

			if(modDate) description.append('<p><small><em>' + modDate + '</em></small></p>');
		}
	});
})(jQuery);
*/

// START: SMOOTH SCROLLING FOR ANCHOR LINKS
jQuery(function($) {
	$('a[href*="#"]').not('[href="#"]').not('[href*="#!"]').on('click', function(e) {
		var hash = this.hash;
		if(hash && $(hash).length) {
			e.preventDefault();
			$(hash)[0].scrollIntoView({
				behavior: 'smooth',
				block   : 'start',
				inline  : 'nearest'
			});
		}
	});
});
// END: SMOOTH SCROLLING FOR ANCHOR LINKS

// START: LOAD SOUNDCITE SCRIPT IF NEEDED
jQuery(function($) {
	$('.soundcite').each(function() {
		cphLoader.loadSoundcite();
	});
});
// END: LOAD SOUNDCITE SCRIPT IF NEEDED

// START: LOAD PDFEMBED SCRIPT IF NEEDED
jQuery(function($) {
	$('.pdf-embed').each(function(i) {
		var pdfId = 'pdf-embed-' + i,
			pdfSrc = $(this).data('src');

		$(this).attr('id', pdfId);

		cphLoader.loadPdfObject(function() {
			PDFObject.embed(pdfSrc, '#' + pdfId);
		});
	});
});
// END: LOAD PDFEMBED SCRIPT IF NEEDED

// START: LOAD FACEBOOK SDK IF NEEDED
jQuery(function($) {
	if($('.fb-video, .fb-post').length) {
		if(!$('div#fb-root').length) {
			$('body').prepend('<div id="fb-root"></div>');
		}
		if(!$('#facebook-jssdk').length) {
			(function(d, s, id) {
				var js, fjs = d.getElementsByTagName(s)[0];
				if(d.getElementById(id)) return;
				js = d.createElement(s);
				js.id = id;
				js.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2&appId=10150152840220381&autoLogAppEvents=1';
				fjs.parentNode.insertBefore(js, fjs);
			}(document, 'script', 'facebook-jssdk'));
		}
	}
});
// END: LOAD FACEBOOK SDK IF NEEDED

// START: CHECK IF AUTOIFRAME SHORTCODES EXIST
jQuery(function($) {
	var autoFrames = $('.auto-size-iframe');
	if(!autoFrames.length)
		return;

	$.each(autoFrames, function(i, v) {
		window.addEventListener('message', function(event) {
			var data = event.data;
			if(data.message === 'cphResizeAutoIframe') {
				if(data.height) {
					$(autoFrames[i]).attr('height', data.height);
					$(autoFrames[i]).css({height: data.height + 'px'});
				}
			}
		}, false);
	});
});
// END: START: CHECK IF AUTOIFRAME SHORTCODES EXIST
jQuery(function($) {
    let navScrolls = $('.scrollable-menu');
    navScrolls.on('wheel', function(e) {
        let scrollable = e.currentTarget,
            width = scrollable.offsetWidth,
            scrollWidth = scrollable.scrollWidth,
            maxScroll = scrollWidth - width,
            scrollLeft = scrollable.scrollLeft,
            deltaY = e.originalEvent.deltaY,
            isScrollRight = deltaY > 0;

        if(scrollWidth <= width) return; // scroll not available
        if(maxScroll <= 0) return; // no max scroll (redundant with above)
        if(deltaY === 0) return; // using left/right scroll wheel
        if(isScrollRight && (scrollLeft >= maxScroll)) return; // scrolling right and max scroll reached
        if(!isScrollRight && (scrollLeft <= 0)) return; // scrolling left and min scroll reached

        e.preventDefault();

        scrollable.scrollLeft += deltaY;
    });
});

(function($) {
    window.subscribedNewsletters = window.subscribedNewsletters || [];

    if(!cphGlobal.hasSessionStorage()) return;

    const getEmail = function() {
        return (cphGlobal.getEmail() || '').toLowerCase().trim();
    };

    const getSubscribedNewsletters = function(email) {
        if(!email) return null;
        const subscribedNewsletters = JSON.parse(sessionStorage.getItem('subscribedNewsletters') || '{}');
        if(email === subscribedNewsletters.email) return subscribedNewsletters.subscribed || [];
        return null;
    }

    const setSubscribedNewsletters = function(subscribedNewsletters) {
        sessionStorage.setItem('subscribedNewsletters', JSON.stringify(subscribedNewsletters || {}));
    }

    const removeSubscribedNewsletters = function() {
        sessionStorage.removeItem('subscribedNewsletters');
    }

    window.subscribedNewsletters = getSubscribedNewsletters(getEmail());

    $(document).one('mg2:loggedOut', removeSubscribedNewsletters);

    if(window.subscribedNewsletters !== null) return;

    $(function() {
        $(document).one('mg2:loggedIn mg2:subscribed mg2:notSubscribed mg2:failed', function() {
            const email = getEmail();
            if(!email) return;
            const request = $.getJSON(cphNlHost + '/api/subscriber/get/lists', {email:email});
            request.done(function(data, status, jqXHR) {
                if(jqXHR.status === 200 && data.email) {
                    setSubscribedNewsletters(data || {});
                    window.subscribedNewsletters = getSubscribedNewsletters(data.email);
                }
            });
        });
    });
})(jQuery);

window.tpl2018 = window.tpl2018 || {};
(function($) {

    tpl2018.addGallery = function(articles) {
        if(typeof articles === 'object') {
            $.each(articles, function(i, article) {
                article = $(article);

                var uuid = article.data('uuid'),
                    isVideo = article.find('.video-thumbnail-overlay').length,
                    thumb = article.find('.story-thumbnail-inner');

                if(!uuid) return; // if uuid not set, we can't proceed

                if(isVideo) return; // no slideshow if first slide is a video

                if(!thumb.length) return; // if not present, this won't work

                // Get image object from feed server. This means that this will only work for Naviga publications
                var json = $.getJSON('/smi/feeds/json/images/?uuid=' + uuid + '&size=jumbo');
                json.done(function(data) {
                    var validImages = [];
                    $.each(data.images, function(i, image) {
                        if(image.video.id) return; // exclude videos
                        if(image.image.orientation !== 'horizontal') return; // exclude portrait images
                        validImages.push(image);
                    });

                    if(validImages.length <= 1) return;

                    var sContainer = $('<div class="swiper-container"/>'),
                        sWrapper = $('<div class="swiper-wrapper"/>'),
                        sSlide = $('<div class="swiper-slide"/>'),
                        sImg = $('<img class="swiper-lazy"/>'),
                        sPl = $('<div class="swiper-lazy-preloader swiper-lazy-preloader-white"/>'),
                        slides = [];

                    sContainer.css({
                        position: 'absolute',
                        width   : '100%',
                        height  : '100%'
                    });

                    sImg.css({
                        objectFit: 'cover'
                    });

                    $.each(validImages, function(i, obj) {
                        var img = obj.image,
                            thisImg = sImg.clone(),
                            thisSlide = sSlide.clone();

                        thisImg.attr('sizes', '100vw');
                        thisImg.attr('alt', img.alt);

                        if(i === 0) { // first slide
                            thisImg.attr('src', img.href);
                            thisImg.attr('srcset', img.srcset);
                            thisImg.removeClass('swiper-lazy');

                            thisSlide.html(thisImg);
                        } else {
                            thisImg.attr('data-src', img.href);
                            thisImg.attr('data-srcset', img.srcset);

                            thisSlide.html([thisImg, sPl.clone()]);
                        }

                        slides.push(thisSlide);
                    });

                    if(slides.length) {
                        sWrapper.html(slides);
                        sContainer.html(sWrapper);
                        thumb.html(sContainer);

                        cphLoader.loadSwiper(function() {
                            new Swiper(sContainer[0], {
                                navigation    : false,
                                allowTouchMove: false,
                                autoplay      : {
                                    delay            : 4000,
                                    pauseOnMouseEnter: true
                                },
                                preloadImages : false,
                                lazy          : {
                                    loadPrevNext: true
                                },
                                effect        : 'fade',
                                fadeEffect    : {
                                    crossFade: true
                                },
                                loop          : true,
                                slidesPerView : 1
                            });
                        });
                    }
                });
            });
        }
    };
})(jQuery);